
export enum FestivalCategoryType {
    Undefined = 'Undefined',
    Default = 'Default',
    Dense = 'Dense'
}
